// src/pages/Marketing/MarketingApp.js
//
// The marketing site's own top-level component — mounted by App.js only on
// posflect.com/www.posflect.com (see App.js's own isMarketingHost check).
// Deliberately isolated from BOTH TenantApp (no AuthContext/I18nContext —
// this visitor is anonymous and this site has nothing to do with any one
// tenant) and PlatformApp (no PlatformAuthContext — a Super Admin session
// has nothing to do with this either), the same "these trees must never
// collide" reasoning PlatformApp.js's own doc comment already applies to
// itself relative to TenantApp. A single real route today (MarketingHome),
// still wrapped in its own BrowserRouter/Routes for the same reason
// PlatformApp.js is: so a future second marketing page (a pricing page, a
// blog) has somewhere to go without restructuring this file.
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { MarketingI18nProvider } from "./MarketingI18nContext";
import MarketingHome from "./MarketingHome";
import "./MarketingApp.css";

// GOOGLE_FONTS_HREF is injected at runtime, only while MarketingApp is
// mounted, rather than baked into public/index.html — that file is shared
// by every host this one build serves (tenant subdomains, admin.posflect.com),
// and neither of those trees needs this site's own display/body typeface.
const GOOGLE_FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600&family=Work+Sans:wght@400;500;600;700&display=swap";

function useMarketingFonts() {
  useEffect(() => {
    if (document.getElementById("mkt-fonts")) return;
    const link = document.createElement("link");
    link.id = "mkt-fonts";
    link.rel = "stylesheet";
    link.href = GOOGLE_FONTS_HREF;
    document.head.appendChild(link);
  }, []);
}

export default function MarketingApp() {
  useMarketingFonts();

  return (
    <MarketingI18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<MarketingHome />} />
        </Routes>
      </BrowserRouter>
    </MarketingI18nProvider>
  );
}
